import { render, staticRenderFns } from "./InstitutionChoose.vue?vue&type=template&id=24f5fe94&scoped=true&"
import script from "./InstitutionChoose.vue?vue&type=script&lang=js&"
export * from "./InstitutionChoose.vue?vue&type=script&lang=js&"
import style0 from "./InstitutionChoose.vue?vue&type=style&index=0&id=24f5fe94&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f5fe94",
  null
  
)

export default component.exports